<template>
  <div class="mt-3">

    <v-row>
      <v-col cols="12">
        <v-card class="rounded-lg shadow flex d-flex flex-column">
          <v-card-title>
            Tâches terminées
          </v-card-title>
          <v-divider></v-divider>

          <v-card-title>
            <div>
              <v-text-field
                  v-model="keyword"
                  append-icon="mdi-magnify"
                  @keydown.enter="getCompletedInvestigations"
                  hint="Appuyez sur ↵ Entrée pour rechercher"
                  clearable
                  @click:clear="[keyword=null,getCompletedInvestigations()]"
                  dense
                  filled
                  persistent-hint
                  placeholder="Recherche..."
                  rounded
              ></v-text-field>
            </div>
            <v-spacer/>

            <v-btn color="grey" text
                   @click="getCompletedInvestigations(true)">
              <v-icon left>mdi-refresh</v-icon>
              Mettre à jour
            </v-btn>

          </v-card-title>

          <v-divider/>

          <v-card-text v-if="isLoading">
            <v-skeleton-loader height="300" type="table"/>
          </v-card-text>

          <div v-else>
            <v-card-text class="pa-0">
              <v-simple-table v-if="investigations.length">
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th>Campagne</th>
                    <th class="text-no-wrap">Enquête</th>
                    <th class="text-no-wrap">Nom d'utilisateur</th>
                    <th class="text-no-wrap">Tél d'utilisateur</th>
                    <th>Points</th>
                    <th>Date de réponse</th>
                    <th>Statut</th>
                    <th>ID.T</th>
                    <th>Actions</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item ,index) in investigations" :key="index">


                    <td class="text-no-wrap">
                      {{ item.investigation.opus_campaign.name['fr'] }}
                    </td>

                    <td class="text-no-wrap">
                      {{ item.investigation.name['fr'] }}
                    </td>

                    <td class="text-no-wrap">
                      {{ item.user?.name }}
                    </td>

                    <td class="text-no-wrap">
                      {{ item.user?.phone }}
                    </td>

                    <td class="text-no-wrap gifty-text font-weight-medium">
                      {{ item.investigation.winning_points }} Pts
                    </td>

                    <td class="text-no-wrap">
                      {{ item.answered_at }}
                    </td>

                    <td>
                      <v-chip small
                              :text-color="item.status_text['text_color']"
                              :class="item.status_text['class']"
                              class="font-weight-medium">
                        {{ item.status_text['text'] }}
                      </v-chip>
                    </td>

                    <td :class="{'red--text': !item.opus_point_history?.transaction_id}">
                      {{ item.opus_point_history?.transaction_id || "Erreur" }}
                    </td>


                    <td class="text-no-wrap">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs"
                                 @click="$refs.responsesDialog.open(item)"
                                 v-on="on" color="gifty" icon>
                            <v-icon>mdi-eye-plus</v-icon>
                          </v-btn>
                        </template>
                        <span>Voir les réponses</span>
                      </v-tooltip>
                    </td>

                  </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <div v-else>
                <NoResults @reload="getCompletedInvestigations"/>
              </div>
            </v-card-text>

            <v-divider/>

            <v-card-actions>

              <div :style="{width: '120px'}">
                <v-select v-model="perPage"
                          :items="[10,20,30,50,100]"
                          dense
                          hide-details
                          label="Ligne par page"
                          outlined></v-select>
              </div>

              <v-spacer/>

              <v-pagination v-model="pagination.current"
                            :length="pagination.total"
                            circle
                            total-visible="8"
                            @input="getCompletedInvestigations"></v-pagination>

            </v-card-actions>

          </div>

        </v-card>
      </v-col>
    </v-row>

    <ResponsesDialog ref="responsesDialog" :status="'completed'" :view="'dashboard'"/>

  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import NoResults from "@/components/NoResults.vue";
import ResponsesDialog from "@/views/opus/backoffice/components/ResponsesDialog.vue";

export default {
  components: {ResponsesDialog, NoResults},
  props: ['opus_campaign_id'],
  data() {
    return {
      keyword: null,
      isLoading: false,
      total: 0,
      perPage: 10,
      pagination: {
        current: 1,
        total: 0
      },
      investigations: [],
    }
  },
  methods: {
    getCompletedInvestigations() {
      this.isLoading = true
      if (!this.opus_campaign_id) return;
      HTTP.get('/v1/opus/backoffice/investigations?page=' + this.pagination.current, {
        params: {
          keyword: this.keyword,
          perPage: this.perPage,
          opus_campaign_id: this.opus_campaign_id,
          status: 'completed',
        }
      }).then(res => {
        this.pagination.current = res.data.data.current_page;
        this.pagination.total = res.data.data.last_page;
        this.total = res.data.data.total;
        this.investigations = res.data.data.data
        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
  },
  created() {
    this.getCompletedInvestigations()
  },
  watch: {
    perPage() {
      this.pagination.current = 1
      this.getCompletedInvestigations();
    },
    opus_campaign_id(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getCompletedInvestigations();
      }
    }
  },
}
</script>

<style>

</style>